module.exports = __webpack_public_path__ + "img/Obstfelder_Folkeliv_på_Karl_Johan.e2fbe99c.jpg";